<template>
	<div class="bg-white px-3 pt-2" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<el-button type="primary" size="mini">查询</el-button>
		<!-- 头部标签页 -->
		<el-tabs v-model="tabIndex" @tab-click="getList"><el-tab-pane :label="tab.name" :key="tabI" v-for="(tab, tabI) in tabbars"></el-tab-pane></el-tabs>

		<!-- 商品列表 -->
		<el-table class="" :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column align="center" prop="id" width="60" label="编号" fixed="left"></el-table-column>
			<el-table-column align="center" width="100" label="关联生产单">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" plain>手机组装</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="100" label="生产成品">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" plain>移动设备</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="id" width="60" label="单位"></el-table-column>
			<el-table-column align="center" prop="id" width="60" label="数量"></el-table-column>
			<el-table-column align="center" prop="id" width="80" label="及格数量"></el-table-column>
			<el-table-column align="center" prop="id" width="80" label="不及格数量"></el-table-column>

			<el-table-column align="center" width="90" label="质检员">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" plain>又是我</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" width="90" label="质检状态">
				<template slot-scope="scope">
					<el-button type="info" size="mini" plain>已检验</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="create_time" width="140" label="质检时间"></el-table-column>
			<el-table-column align="center" width="90" label="生产员">
				<template slot-scope="scope">
					<el-button type="success" size="mini" plain>梁工</el-button>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="create_time" width="140" label="提交时间"></el-table-column>
			<!-- 操作 -->
			<el-table-column align="center" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<div v-if="tab != 'delete'">
						<el-button type="primary" size="mini" @click="openModel(scope)">查看</el-button>
						<el-button type="warning" size="mini">质检入库</el-button>
					</div>
					<div v-else>暂无操作</div>
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh" width="160vh">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<div style="width: 33%;">
					<el-form :rules="rules" ref="form" :model="form" label-width="80px">
						<el-form-item label="信息编号"><el-input v-model="form.id" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="手机号码"><el-input v-model="form.phone" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="地区"><el-input v-model="form.city" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="客户状态">
							<el-button type="success" size="mini" v-if="form.state == 0">无</el-button>
							<el-button type="success" size="mini" v-else>潜在客户</el-button>
						</el-form-item>
						<el-form-item label="关注人">
							<el-button type="success" size="mini">{{ form.gz }}</el-button>
						</el-form-item>
						<el-form-item label="责任人">
							<el-button type="success" size="mini">{{ form.zr }}</el-button>
						</el-form-item>
						<el-form-item label="责任人"><el-button type="info" size="mini">无</el-button></el-form-item>
						<el-form-item label="创建人">
							<el-button type="success" size="mini">{{ form.user }}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form :rules="rules" ref="form" :model="form" label-width="80px">
						<el-form-item label="客户名称"><el-input v-model="form.name" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="座机号码"><el-input v-model="form.zjphone" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="详细地址"><el-input v-model="form.xxdz" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="线索数量"><el-input v-model="form.xssl" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="共享商务">
							<el-button type="success" size="mini">{{ form.gxsw }}</el-button>
						</el-form-item>
						<el-form-item label="释放时间"><el-input v-model="form.desc" placeholder="备注" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="创建时间"><el-input v-model="form.time" placeholder="备注" size="mini" style="width: 95%;"></el-input></el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form :rules="rules" ref="form" :model="form" label-width="80px">
						<el-form-item label="联系人">
							<el-button type="success" size="mini">{{ form.lxr }}</el-button>
						</el-form-item>
						<el-form-item label="电子邮件"><el-input v-model="form.email" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="备注"><el-input v-model="form.desc" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="线索更新时间"><el-input v-model="form.xstime" size="mini" style="width: 95%;"></el-input></el-form-item>
					</el-form>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit(tableData)">确 定</el-button>
			</div>
		</el-dialog>
		<el-drawer title="查看" :visible.sync="drawer" :direction="direction" :before-close="handleClose" size="1200px">
			<div class="ml-4 mr-4 d-flex" style="width: 100%;">
				<div style="width: 33%;">
					<el-form :rules="rules" ref="form" :model="form" label-width="80px">
						<el-form-item label="信息编号"><el-input v-model="form.id" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="部门"><el-button type="success" size="mini">公司总部</el-button></el-form-item>
						<el-form-item label="备注"><el-input v-model="form.desc" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="待结算"><el-input v-model="form.xssl" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="客户"><el-button type="primary" size="mini">又是我</el-button></el-form-item>
						<el-form-item label="申请单"><el-button type="success" size="mini">T100819</el-button></el-form-item>
						<el-form-item label="下单时间"><el-input v-model="form.time" size="mini" style="width: 95%;"></el-input></el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form :rules="rules" ref="form" :model="form" label-width="80px">
						<el-form-item label="创建人"><el-button type="success" size="mini">李云龙</el-button></el-form-item>
						<el-form-item label="名称"><el-input v-model="form.name" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="商品总额"><el-input v-model="form.id" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="产品数量"><el-input v-model="form.xssl" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="仓库仓位"><el-button type="primary" size="mini">美国白宫</el-button></el-form-item>
						<el-form-item label="审核状态"><el-button type="success" size="mini">已通过</el-button></el-form-item>
						<el-form-item label="出库时间"><el-input v-model="form.time" size="mini" style="width: 95%;"></el-input></el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form :rules="rules" ref="form" :model="form" label-width="80px">
						<el-form-item label="业务员"><el-button type="success" size="mini">奥特曼</el-button></el-form-item>
						<el-form-item label="订单号"><el-input v-model="form.phone" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="订单总额"><el-input v-model="form.id" size="mini" style="width: 95%;"></el-input></el-form-item>
						<el-form-item label="单据类型"><el-button type="primary" size="mini">销售出库单</el-button></el-form-item>
						<el-form-item label="收款账户"><el-button type="info" size="mini">无</el-button></el-form-item>
						<el-form-item label="出库状态"><el-button type="success" size="mini">已处理</el-button></el-form-item>
					</el-form>
				</div>
			</div>
			<div class="ml-4 mr-4" style="width: 100%;">
				<el-form :rules="rules" ref="form" :model="form" label-width="80px">
					<el-form-item label="出库信息"><el-input v-model="form.desc" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="订单号">
						<el-table :data="tableDatac" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }">
							<el-table-column prop="id" label="序号" width="60"></el-table-column>
							<el-table-column prop="name" label="产品名称"></el-table-column>
							<el-table-column prop="noid" label="产品编码"></el-table-column>
							<el-table-column prop="gemc" label="规格名称"></el-table-column>
							<el-table-column prop="gebm" label="规格编码"></el-table-column>
							<el-table-column prop="pch" label="批次号"></el-table-column>
							<el-table-column prop="dw" label="单位"></el-table-column>
							<el-table-column prop="dj" label="单价"></el-table-column>
							<el-table-column prop="num" label="数量"></el-table-column>
							<el-table-column prop="je" label="合计"></el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
		</el-drawer>

		<el-drawer title="企业微信消息发送" :visible.sync="drawera" :direction="direction" size="600px">
			<div class="ml-4 mr-4" style="width: 100%;">
				<el-form :rules="rules" ref="form" :model="form" label-width="80px">
					<el-form-item label="信息数量"><el-input v-model="form.id" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="标题字段">
						<el-select v-model="values" placeholder="请选择" size="mini">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="消息标题"><el-input v-model="form.desc" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="卡片描述">
						<el-select v-model="values" placeholder="请选择" size="mini">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="卡片链接"><el-input v-model="form.desc" size="mini" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="选择个人">
						<el-radio-group v-model="radio4" size="mini">
							<el-radio-button label="个人"></el-radio-button>
							<el-radio-button label="部门"></el-radio-button>
							<el-radio-button label="群聊"></el-radio-button>
							<el-radio-button label="全部"></el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="选择个人"><el-button type="success" size="mini">又是我</el-button></el-form-item>
				</el-form>
			</div>
		</el-drawer>
		<el-drawer title="结算" :visible.sync="drawerb" :direction="direction" size="400px">
			<div class="ml-4 mr-4" style="width: 100%;">
				<el-form :rules="rules" ref="form" :model="form" label-width="80px">
					<el-form-item label="信息数量"><el-input-number v-model="num" @change="handleChange" size="mini"></el-input-number></el-form-item>
					<el-form-item label="结算账户">
						<el-select v-model="values" placeholder="请选择" size="mini">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
						<div><el-button type="primary" size="mini">确定提交</el-button></div>
					</el-form-item>
				</el-form>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			preUrl: 'goods', // api
			activeNames: ['1'],
			tabIndex: 0,
			tableDatac: [
				{
					id: 1,
					name: '文具',
					noid: 'P156',
					gemc: '无印良品',
					gebm: 'T15612',
					pch: 748,
					dw: '盒',
					num: 41569,
					dj: 15,
					je: 41515
				},
				{
					id: 2,
					name: '滑板',
					noid: 'P256',
					gemc: '有指脸谱',
					gebm: 'T13112',
					pch: 748,
					dw: '块',
					num: 8969,
					dj: 85,
					je: 2313123
				}
			],
			tabbars: [
				{ name: '全部', key: 'all' },
				{ name: '未检验', key: 'checking' },
				{ name: '已检验', key: 'saling' },
			],
			form: {
				id: 789,
				name: '恒大集团',
				phone: '1256545645',
				zjphone: '020-656846',
				lxr: '打工仔A',
				email: '45848@qq.com',
				city: '广东省-广州市-天河区',
				xxdz: '广东省广州市天河区体育西地铁出口左转60000米',
				desc: '有钱任性',
				state: 1,
				xssl: 99,
				xstime: '2022-08-22 19:55:21',
				time: '2022-08-22 19:55:21',
				gz: '打工仔F',
				zr: '打工仔O',
				user: '打工仔A',
				gxsw: '打工仔V'
			},
			tableData: [],
			cateOptions: [],
			createModel: false,
			value: '更多',
			drawer: false,
			drawera: false,
			drawerb: false,
			direction: 'rtl',
			options: [
				{
					value: '选项1',
					label: '黄金糕'
				},
				{
					value: '选项2',
					label: '双皮奶'
				},
				{
					value: '选项3',
					label: '蚵仔煎'
				},
				{
					value: '选项4',
					label: '龙须面'
				},
				{
					value: '选项5',
					label: '北京烤鸭'
				}
			],
			values: '',
			radio4: '个人',
			num: 99
		};
	},
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name;
			}
			let str = '';
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--';
			}
			return str + ' ' + item.name;
		}
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user,
			navBar: state => state.menu.navBar
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	// 生命周期，调用__getData生成的数据
	created() {},
	// 生命周期监听页面
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 274; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {
		gotodo(e) {
			this.$router.push({
				name: 'scgl_scrw_scxd_create',
				query: {
					data: e
				}
			});
		},
		gotodos(e) {
			this.$router.push({
				name: 'zjb_zdmrp',
				query: {
					id: e
				}
			});
		},
		gotos(e) {
			console.log(e);
			this.$router.push({
				name: e
			});
		},
		// 调转基础设置、商品规格、商品属性、媒体设置、商品详情页面
		navigate(name, id) {
			this.$router.push({
				name,
				params: { id }
			});
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			console.log(this.user);
			this.tableData = e.list;
			this.cateOptions = e.cates;
		},
		// 上下架
		changeStatus(item) {
			item.status = item.status === 1 ? 0 : 1;
		},
		// 清空筛选条件
		clearSearch() {
			this.form = {
				title: '',
				category_id: ''
			};
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.form.title = e;
			}
			// 高级搜索
			this.getList();
		},
		// 删除商品/恢复商品
		doEvent(key) {
			if (this.ids.length === 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的商品'
				});
			}
			this.showLoading();
			this.axios
				.post(
					'/admin/goods/' + key,
					{
						//删除商品/恢复商品api（restore、destroy区别 删除/回复）
						ids: this.ids
					},
					{
						token: true
					}
				)
				.then(res => {
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.getList();
					this.hideLoading();
				})
				.catch(err => {
					this.hideLoading();
				});
		},
		// 上下架
		changeStatus(status) {
			if (this.ids.length === 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的商品'
				});
			}
			this.showLoading();
			this.axios
				.post(
					'/admin/goods/changestatus',
					{
						//商品上下架api
						ids: this.ids,
						status
					},
					{
						token: true
					}
				)
				.then(res => {
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.getList();
					this.hideLoading();
				})
				.catch(err => {
					this.hideLoading();
				});
		},
		// 审核商品 ischeck审核 1同意 2拒绝
		checkGoods(item, ischeck) {
			this.layout.showLoading();
			this.axios
				.post(
					'/admin/goods/' + item.id + '/check',
					{
						//审核商品 api
						ischeck
					},
					{
						token: true
					}
				)
				.then(res => {
					this.getList();
					this.$message({
						type: 'success',
						message: '操作成功'
					});
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		},
		openModel(e = false) {
			console.log(e);
			this.tableData[e.row.id - 1] = {
				id: e.row.id,
				create_time: '2022-08-19 14:40:20',
				name: e.row.name,
				class: e.row.class,
				state: 1,
				user: '你好啊'
			};
			// 打开dialog
			this.createModel = true;
		},
		opct() {
			this.drawer = true;
		},
		opcta() {
			this.drawera = true;
		},
		opctb() {
			this.drawerb = true;
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		}
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
    cursor: pointer;
    color: #ff8c00;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
